<template>
  <div
    v-if="isVisible"
    class="artificial-intelligence-icon-container"
    title="IA Habilitada"
    aria-label="IA Habilitada"
    role="img"
    aria-hidden="true"
    :style="{ marginRight: addMarginRight }">
    <svg
      version="1.1"
      class="artificial-intelligence-icon"
      width="32"
      height="32"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="6"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path d="M454.613,0H57.387C25.707,0,0,25.707,0,57.387v397.227C0,486.293,25.707,512,57.387,512h397.227
              c31.68,0,57.387-25.707,57.387-57.387V57.387C512,25.707,486.293,0,454.613,0z M490.667,454.613
              c0,19.947-16.107,36.053-36.053,36.053H57.387c-19.947,0-36.053-16.107-36.053-36.053V57.387
              c0-19.947,16.107-36.053,36.053-36.053h397.227c19.947,0,36.053,16.107,36.053,36.053V454.613z" />
            <g transform="translate(256, 256) scale(1.3) translate(-256, -256)">
              <path
                d="M216,149.333l-66.667,213.333h27.627l19.947-66.133h68.267l20.587,66.133h28.267L247.68,149.333H216z M202.027,276.267
                l18.453-59.733c3.84-13.333,7.147-27.947,10.027-41.6h0.96c2.88,13.333,6.187,27.627,10.347,41.92l18.773,59.413H202.027z" />
              <path d="M356.587,150.72c-9.6,0-16.747,7.253-16.747,17.067c0,9.493,6.72,16.747,16.427,16.747h0.32
                c10.24,0,16.747-7.253,16.747-16.747C373.333,157.973,366.613,150.72,356.587,150.72z" />
              <rect x="343.467" y="209.067" width="26.667" height="153.6" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ArtificialIntelligenceIcon',
  props: {
    addMarginRight: {
      type: String,
      default: '0px'
    }
  },
  computed: {
    isVisible () {
      return this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.user && this.$store.state.auth.user.hasAI === true
    }
  }
}
</script>

<style lang="scss" scoped>
.artificial-intelligence-icon-container {
  font-size: 0 !important;
}
.artificial-intelligence-icon {
  width: 32px;
  height: 32px;
  color: #000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/ArtificialIntelligenceIcon.vue